import {
  CONSOLE_PASSWORD_RULE_MESSAGE,
  CONSOLE_USERNAME_RULE_MESSAGE,
  isValidConsolePassword,
  isValidConsoleUsername,
} from '@wxproto-desk/shared'

/**
 * Field-level validators shared by the auth forms (register / forgot-password /
 * profile edit). Each returns an error message for display below the input,
 * or '' when the value passes.
 */

export function validateUsernameField(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return '请输入用户名'
  if (!isValidConsoleUsername(trimmed)) return CONSOLE_USERNAME_RULE_MESSAGE
  return ''
}

export function validateEmailField(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return '请输入邮箱'
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return '邮箱格式不正确'
  return ''
}

export function validatePasswordField(value: string): string {
  if (!value) return '请输入密码'
  if (!isValidConsolePassword(value)) return CONSOLE_PASSWORD_RULE_MESSAGE
  return ''
}

export function validateConfirmPasswordField(password: string, confirm: string): string {
  if (!confirm) return '请再次输入密码'
  if (password !== confirm) return '两次输入的密码不一致'
  return ''
}
